import React from "react";
import { Controller } from "react-hook-form";
import { Textarea } from "@chakra-ui/react";
import { TextareaProps } from "@chakra-ui/textarea/dist/types/textarea";

import { FieldPrototype } from "./FieldPrototype";

interface IProps extends TextareaProps {
  label: string;
  isRequired?: boolean;
  name: string;
}

const TextAreaField = ({
  isRequired = true,
  label,
  name,
  rows = 3,
  ...textAreaProps
}: IProps) => {
  return (
    <FieldPrototype isRequired={isRequired} label={label} name={name}>
      {({
        hasError,
        methods: {
          formState: { isSubmitting },
        },
      }) => (
        <Controller
          name={name}
          render={(props) => (
            <Textarea
              id={`${name}-textarea`}
              rows={rows}
              isInvalid={hasError}
              disabled={isSubmitting}
              {...textAreaProps}
              {...props}
            />
          )}
        />
      )}
    </FieldPrototype>
  );
};

export { TextAreaField };
